<div class="readonly-cell">
  <div class="readonly-cell__value">
    <span>{{ value }}</span>
  </div>
  <div class="readonly-cell__lock">
    <img src="assets/img/lock.svg" class="readonly-cell__lock__icon">
  </div>
</div>
